export default __webpack_public_path__ + "static/Cashflow 101+202-1-b487707e5719f113a3c526702afe8fb1.png";